// WebSocket-Client mit Reconnect. Im Vordergrund offen, im Hintergrund pausiert (Konzept: kein Poll auf Mobilfunk).
export interface GameEvent {
  type: string;
  hiveId?: number;
  detail?: Record<string, unknown>;
  at: string;
}

type Listener = (ev: GameEvent) => void;

export class EventSocket {
  private ws: WebSocket | null = null;
  private listeners = new Set<Listener>();
  private attempt = 0;
  private timer: number | null = null;
  private stopped = false;

  constructor(
    private url = `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}/ws`,
  ) {}

  start() {
    this.stopped = false;
    this.connect();
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  stop() {
    this.stopped = true;
    document.removeEventListener('visibilitychange', this.onVisibility);
    if (this.timer) window.clearTimeout(this.timer);
    this.ws?.close();
    this.ws = null;
  }

  /** Nach Login/Logout neu verbinden, damit der Server die Session neu liest. */
  reconnect() {
    this.ws?.close();
  }

  on(l: Listener) {
    this.listeners.add(l);
    return () => this.listeners.delete(l);
  }

  private onVisibility = () => {
    if (document.visibilityState === 'visible') {
      if (!this.ws || this.ws.readyState > WebSocket.OPEN) this.connect();
    } else {
      this.ws?.close();
    }
  };

  private connect() {
    if (this.stopped || document.visibilityState !== 'visible') return;
    const ws = new WebSocket(this.url);
    this.ws = ws;
    ws.onopen = () => {
      this.attempt = 0;
    };
    ws.onmessage = (m) => {
      try {
        const ev = JSON.parse(String(m.data)) as GameEvent;
        for (const l of this.listeners) l(ev);
      } catch {
        /* pong o. ae. */
      }
    };
    ws.onclose = () => {
      if (this.ws === ws) this.ws = null;
      if (this.stopped || document.visibilityState !== 'visible') return;
      const delay = Math.min(30_000, 1000 * 2 ** this.attempt++);
      this.timer = window.setTimeout(() => this.connect(), delay);
    };
  }
}
